var React = require('react');

function Overflow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#20BBE6"},[React.createElement("ellipse",{"cx":"20","cy":"12","rx":"2.00002","ry":"2","transform":"rotate(-180 20 12)","key":0}),React.createElement("ellipse",{"cx":"12","cy":"12","rx":"2.00002","ry":"2","transform":"rotate(-180 12 12)","key":1}),React.createElement("ellipse",{"cx":"3.99998","cy":"12","rx":"2.00002","ry":"2","transform":"rotate(-180 3.99998 12)","key":2})]));
}

Overflow.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Overflow;

Overflow.default = Overflow;
